import React, { useState, useEffect } from 'react';
import s from './SearchInput.scss';
import { useInput } from '../../hooks';
import { useAPI } from '../../hooks/APIs/useAPI';
import { HotSearchAPI } from '../../models/API';
import { spmGetParams } from '../../utils/spmHelper';

export const SearchInput = (props: {hotSearch: string[]}) => {
    const { hotSearch } = props;
    const [input, , , changeInput] = useInput('');
    const [hotword, setHotword] = useState('');
    const [hotwordAPI] = useAPI<HotSearchAPI["body"]>('//search.sohu.com/search/hot', {
        status: 0,
        message: '',
        data: [],
    }, []);
    // set hot word
    useEffect(() => {
        if (hotwordAPI.data && hotwordAPI.data.length && !hotword) {
            setHotword(hotwordAPI.data[Math.ceil(Math.random() * hotwordAPI.data.length)]);
        }
    }, [hotwordAPI]);
    const searchClick = () => {
        const keyword = input || hotword;
        const url = `//search.sohu.com/?keyword=${keyword}&type=1&spm=${spmGetParams()}&queryType=outside`;
        window.open(url);
    };
    const serachKeydown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === 13) {
            searchClick();
        }
    };
    return (
        <div className={s.container} data-spm="top-search">
            <input
                className={s.input}
                type="text"
                placeholder={hotSearch[0]}// "搜你想搜的"
                onChange={changeInput} value={input}
                onKeyDown={serachKeydown}
                data-spm-acode="8315"
                data-asm-search="input"
                data-hotSearch={hotSearch}
            />
            <button className={s.searchBtn} onClick={searchClick} data-spm-acode="8316" data-asm-search="button"><i className={['bicon-search', s.icon].join(' ')}/></button>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/SearchInput/index.tsx